<template>
    <h1>Game</h1>

    <Trivia />

</template>

<script>
import Trivia from '../components/Trivia.vue'
export default {
    components: { Trivia }

}
</script>

<style>
</style>